setUserGiftSubscriptionsProcessing